import { render, staticRenderFns } from "./FormAvatarItem.vue?vue&type=template&id=2432bf08&scoped=true&"
import script from "./FormAvatarItem.vue?vue&type=script&lang=js&"
export * from "./FormAvatarItem.vue?vue&type=script&lang=js&"
import style0 from "./FormAvatarItem.vue?vue&type=style&index=0&id=2432bf08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432bf08",
  null
  
)

export default component.exports